import React from 'react';
import { legacyInjectIntl } from 'js/wrapper/injectIntl';
import { Button, Overlay, Popover } from 'react-bootstrap';

class SimplePrompt extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      show: false,
    };

    this.buttonRef = React.createRef();
  }

  handleClick = e => {
    e.preventDefault();
    e.stopPropagation();

    this.setState(prevState => ({ show: !prevState.show }));
  };

  doClose = e => {
    e.preventDefault();
    e.stopPropagation();

    this.setState({ show: false });
  };

  doDelete = e => {
    e.preventDefault();
    e.stopPropagation();

    const { onSuccess } = this.props;
    this.setState({ show: false });
    onSuccess(e);
  };

  render() {
    const {
      intl: { messages },
      container,
      placement,
      buttonLabel,
      iconClass,
      disabled,
      variant,
      size,
      className,
      showLabel,
      showMessage,
    } = this.props;
    const { show } = this.state;

    return (
      <>
        <Button
          ref={this.buttonRef}
          size={size}
          variant={variant}
          className={className}
          onClick={this.handleClick}
          disabled={disabled}
        >
          <i className={iconClass || 'fas fa-trash-alt'} />
          {showLabel && <span className="hidden-xs"> {buttonLabel || messages.delete}</span>}
        </Button>

        <Overlay
          show={show}
          target={this.buttonRef.current}
          placement={placement}
          rootClose
          onHide={() => {
            this.setState({ show: false });
          }}
          container={container !== undefined ? container : undefined}
        >
          <Popover
            className="popover-content"
            style={{ zIndex: 1200 }}
            id={Math.random().toString(16).substring(0, 2)}
          >
            <div className="text-center">{showMessage || messages.are_you_sure}</div>

            <div style={{ minWidth: '140px' }}>
              <div
                className="m-t-10"
                style={{
                  display: 'flex',
                  gap: '8px',
                  flexWrap: 'nowrap'
                }}
              >
                <Button
                  style={{ flex: 1 }}
                  size="sm"
                  className="p-l-5 p-r-5"
                  onClick={this.doClose}
                >
                  {messages.no}
                </Button>
                <Button
                  style={{ flex: 1 }}
                  size="sm"
                  className="p-l-5 p-r-5"
                  variant="danger"
                  onClick={this.doDelete}
                >
                  {buttonLabel || messages.delete}
                </Button>
              </div>
            </div>
          </Popover>
        </Overlay>
      </>
    );
  }
}
SimplePrompt.defaultProps = {
  placement: 'top',
  disabled: false,
  variant: 'danger',
  size: 'sm',
  className: 'btn-rounded',
  showLabel: true,
};

export default legacyInjectIntl(SimplePrompt);
